export const SYSTEM_VERSION = "0.0.2";

export const USER_KEY   = '_UniAstroUser';
export const USER_TOKEN = '_UniAstroUserToken';

const HOST = '34.205.179.32';
const HTTP = 'http://';
const PORT = ':5050'

// Variáveis padrões
export const BASE_API  = HTTP+HOST+PORT+'/api/v1';
export const BASE_OAPI = HTTP+HOST+PORT+'/o-api/v1';
export const BASE_AUTH = HTTP+HOST+PORT+'/auth';
export const API_STATIC = HTTP+HOST+PORT+'/static';
